export const SERVICE_URLS: any = {
    GET_ALL_LOOKUPS: { url: '/Public/GetAllLookups', method: 'get' },
    GET_APPLICATION_BY_CNIC:{url:'/CustomerAccountOpening/SearchByAppNum',method:'put'},
    GET_APPLICATION_BY_ID:{url:'/CustomerAccountOpening',method:'get'},
    GET_APPLICATION_BY_ACCOUNT:{url:'/CustomerAccountOpening/RDACustomer',method:'get'},
    CREATE_APPLICATION:{url:'/CustomerAccountOpening',method:'post'},
    GET_OTP: { url: '/CustomerAccountOpening/GenerateEmailOTP', method: 'put' },
    VERIFY_OTP: { url: '/CustomerAccountOpening/VerifyEmailOTP', method: 'put' },
    GET_BRANCHES_LOOKUPS: { url: '/Public/GetBranchLovs', method: 'get' },
    INITIATE_WF: { url: '/CustomerAccountOpening/InitiateWF', method: 'put' },
    UPDATE_APP: { url: '/CustomerAccountOpening', method: 'put' }
};